import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "../data/content";
import { EVENT_PAGES } from "../data/pages";
import About from "./about/About";
import Contact from "./contact/Contact";
import EventPage from "./event/EventPage";
import NotFound from "./general/NotFound";
import ScrollToTop from "./general/ScrollToTop";
import Home from "./home/Home";
import Footer from "./layout/Footer";
import Header from "./layout/Header";
import Privacy from "./privacy/Privacy";
import Travel from "./travel/Travel";

//Same page addresses as the Wix site
const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={ROUTES.ABOUT}
            element={<About />}
          />
          {EVENT_PAGES.map((page) => (
            <Route
              key={page.path}
              path={page.path}
              element={<EventPage page={page} />}
            />
          ))}
          <Route
            path={ROUTES.TRAVEL}
            element={<Travel />}
          />
          <Route
            path={ROUTES.CONTACT}
            element={<Contact />}
          />
          <Route
            path={ROUTES.PRIVACY}
            element={<Privacy />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
